import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

/** The schedule level being queried — must match the id being passed. */
export type StandingsGroupBy = 'Division' | 'Conference'

/**
 * Fetches standings for a schedule. Called with a DIVISION's scheduleId the
 * response is that division's teams; with a CONFERENCE's id and
 * `groupBy: 'Conference'` it is that conference's. The raw payload is handed
 * to `toStandingsRows`, which owns the shape mapping and the ordering.
 */
export const getScheduleStandings = async (
  scheduleId: string,
  groupBy: StandingsGroupBy = 'Division'
): Promise<unknown> => {
  const { data } = await req(
    ENDPOINTS.SCHEDULES.GET_STANDINGS(scheduleId, groupBy)
  )
  return data
}
